/**
 * Ask Claude API client. Stateless from the server's perspective —
 * each request includes the full message history so the conversation
 * picks up where it left off.
 */
import { apiFetch } from '../auth/api';

export interface AskMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface AskRequest {
  message: string;
  history?: AskMessage[];
  page_url?: string;
  page_title?: string;
}

export interface AskResponse {
  reply: string;
  model: string;
}

export function askClaude(body: AskRequest): Promise<AskResponse> {
  return apiFetch('/api/help/ask', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
